<template>
  <a-card style="margin: 24px 0">
    <div slot="title" class="title">
      <div class="vertical"></div>
      申请
    </div>
    <div class="main">
      <apply-for-pie key="date2" :data="ProportionUserList"></apply-for-pie>
    </div>
  </a-card>
</template>

<script>
// import chartResize from '@/mixin/chart-resize'
import { getUUID } from '../../../utils/util'
import ApplyForPie from '../module/apply-for-pie.vue'

export default {
  // mixins: [chartResize],
  name: 'Reporting',
  components: {
    ApplyForPie,
  },
  data() {
    return {
      id: getUUID(),
      ProportionUserList: [],
      nums: 0,
    }
  },
  mounted() {
    this.getList()
    // this.getProportionUserList()
  },
  methods: {
    getList() {
      //表数量状态
      this.$http.get('/pipe-network/engineering_project_applys/centre-left').then((res) => {
        console.log(res.data, '申请')
        let datas = res.data
        if (datas.length != null) {
          let lists = []
          for (let i = 0; i < datas.length; i++) {
            lists.push({
              name: datas[i].typeName,
              value: datas[i].num,
            })
          }
          this.ProportionUserList = lists
        }
      })
    },
  },
}
</script>

<style lang='less' scoped>
/deep/.ant-card-body {
  padding: 0;
}
.a-card {
  width: 100%;
  height: 100%;
}
.vertical {
  width: 4px;
  height: 18px;
  margin-right: 10px;
  background: #0265ff;
  border-radius: 3px;
}
.title {
  display: flex;
  align-items: center;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #101010;
  letter-spacing: 0.63px;
  font-weight: 600;
}
.extra {
  font-family: MicrosoftYaHei;
  font-size: 12px;
  color: #a7afb5;
  letter-spacing: 0.48px;
  text-align: right;
  font-weight: 400;
}
.main {
  width: 100%;
  height: 269px;
}
</style>